import { render, staticRenderFns } from "./virtualSalesSetting.vue?vue&type=template&id=7c8a8444&scoped=true"
import script from "./virtualSalesSetting.vue?vue&type=script&lang=js"
export * from "./virtualSalesSetting.vue?vue&type=script&lang=js"
import style0 from "./virtualSalesSetting.vue?vue&type=style&index=0&id=7c8a8444&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8a8444",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c8a8444')) {
      api.createRecord('7c8a8444', component.options)
    } else {
      api.reload('7c8a8444', component.options)
    }
    module.hot.accept("./virtualSalesSetting.vue?vue&type=template&id=7c8a8444&scoped=true", function () {
      api.rerender('7c8a8444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/components/virtualSalesSetting.vue"
export default component.exports